import SftGlobalData from '../../library/SftGlobalData';
import { shopImageBase } from './config/configHelpers';
import { webshopErrorText } from './_webshopNotice';

/**
 * Ask a shop to rebuild its statics (crons/generate_statics.php) so the
 * storefront shows a save without waiting for the next cron run.
 *
 * - https shop: a hidden iframe on the script, as the legacy admin did.
 * - http shop (still on a hoster preview host, ….webhosting.be): the https
 *   admin may not load an http page in a frame (mixed content, blocked by the
 *   browser), so the shop's mini-api runs the script itself — POST
 *   /admin/statics through the auth proxy, which can reach http preview hosts.
 *   Needs a mini-api with that route; an older one answers 404.
 *
 * `detail` forces one generator (e.g. '__generateCarousel'); without it the
 * plain run rebuilds what changed lately. Resolves { ok, message }, never
 * rejects.
 */
export const regenerateShopStatics = ({ selectedWebshop, api, login, detail = null, t = null }) => {
    const base = shopImageBase(selectedWebshop?.display_name);
    if (!base) return Promise.resolve({ ok: false, message: 'No webshop URL' });

    if (/^http:\/\//i.test(base)) {
        return SftGlobalData.post('webshop&action=proxy', {
            key:        api,
            webshop_id: selectedWebshop?.id,
            sftUserId:  login?.sft_user_id,
            user:       login?.login,
            method:     'POST',
            path:       '/admin/statics',
            body:       detail ? { detail } : {},
        })
            .then(r => (r?.success
                ? { ok: true, message: 'Statics regenerated' }
                : { ok: false, message: `Statics regeneration failed: ${webshopErrorText(r, t) || 'unknown error'}` }))
            .catch(e => ({ ok: false, message: `Statics regeneration failed: ${e?.message || 'unknown error'}` }));
    }

    const query = detail ? `detail=${encodeURIComponent(detail)}` : 'lng=nl';
    return new Promise((resolve) => {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        let done = false;
        const finish = (ok, message) => {
            if (done) return;
            done = true;
            setTimeout(() => iframe.remove(), 100);
            resolve({ ok, message });
        };
        iframe.onload  = () => finish(true,  'Statics regenerated');
        iframe.onerror = () => finish(false, 'Statics regeneration failed');
        // Most storefront caches finish well under 60s; give it up to that
        // before reporting a timeout so the user knows to retry manually.
        setTimeout(() => finish(false, 'Statics regeneration timed out'), 60000);
        // The cron lives under server/v1/crons/, NOT at the domain root.
        iframe.src = `${base}/server/v1/crons/generate_statics.php?${query}&__cb_=${Date.now()}`;
        document.body.appendChild(iframe);
    });
};
